import { render, staticRenderFns } from "./FcmSettings.vue?vue&type=template&id=029da08d&"
import script from "./FcmSettings.vue?vue&type=script&lang=ts&"
export * from "./FcmSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports